export default function IosPawOutline() {
  return (
    <div
      className="ion-icon-ios-paw-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M443.827,195.5c-4.383-11.73-11.753-20.212-21.317-24.524c-4.389-1.975-8.995-2.976-13.688-2.976
		c-20.025,0-40.372,18.667-50.632,46.454c-12.698,34.42-5.315,68.135,17.173,78.423c4.522,2.071,9.365,3.123,14.394,3.123
		c20.396,0,41.126-17.119,51.581-42.596C449.238,234.121,450.168,212.477,443.827,195.5z M426.214,246.295
		c-7.836,18.898-22.994,32.098-36.862,32.098c-2.809,0-5.488-0.569-7.968-1.694c-14.121-6.394-17.862-31.059-8.518-56.152
		c7.775-20.817,22.448-35.355,35.683-35.355c2.51,0,4.979,0.533,7.34,1.588c6.88,3.067,10.622,9.712,12.551,14.745
		C433.35,214.332,432.518,231.068,426.214,246.295z"/>
	<path d="M153.811,214.454C143.551,186.667,123.204,168,103.179,168c-4.693,0-9.3,1.001-13.689,2.976
		c-9.565,4.312-16.934,12.794-21.317,24.524c-6.341,16.977-5.411,38.621,2.49,57.904C81.118,278.881,101.848,296,122.244,296
		c5.028,0,9.871-1.052,14.394-3.123C159.126,282.589,166.509,248.874,153.811,214.454z M130.616,276.698
		c-2.479,1.125-5.16,1.694-7.968,1.694c-13.868,0-29.026-13.199-36.862-32.098c-6.304-15.227-7.136-31.963-2.226-44.771
		c1.929-5.033,5.671-11.678,12.551-14.745c2.361-1.055,4.83-1.588,7.34-1.588c13.234,0,27.907,14.538,35.683,35.355
		C148.479,245.64,144.737,270.305,130.616,276.698z"/>
	<path d="M198.347,210.601c1.855,0.081,3.727,0.03,5.563-0.151c10.787-1.059,20.54-6.594,28.207-16.008
		c12.371-15.191,15.806-38.974,13.201-63.439C241.336,93.3,221.469,65.161,194.776,64c0,0-3.811,0.008-5.75,0.193
		c-11.776,1.164-22.481,7.283-30.957,17.695c-12.291,15.101-18.198,37.57-15.803,60.104
		C146.202,179.269,170.836,209.404,198.347,210.601z M171.047,91.831c3.923-4.739,10.51-10.577,19.62-11.476
		c1.143-0.113,2.288-0.146,3.404-0.098c18.207,0.792,31.859,23.271,34.936,52.428c2.146,20.15-0.148,40.055-9.845,51.779
		c-4.874,5.898-10.556,9.204-16.881,9.825c-1.081,0.104-2.167,0.133-3.229,0.087c-19.257-0.838-37.414-25.091-40.473-54.067
		C156.611,121.779,161.273,103.656,171.047,91.831z"/>
	<path d="M256,240c-64,0-128,76.074-128,149.128c0,21.798,10.932,39.331,21.667,46.517C162.925,444.516,172.269,448,191.704,448
		c23.093,0,29.325-8.078,40.136-15.205c7.819-5.152,14.572-9.605,24.161-9.605s16.342,4.453,24.16,9.605
		C290.972,439.922,297.203,448,320.297,448c19.434,0,28.778-3.484,42.036-12.355C373.068,428.459,384,410.926,384,389.128
		C384,316.074,320,240,256,240z M353.963,420.776c-10.964,7.337-17.366,9.778-33.666,9.778c-14.225,0-18.624-3.201-25.911-8.51
		c-1.848-1.344-3.759-2.736-5.946-4.177c-8.619-5.682-18.39-12.123-32.439-12.123s-23.82,6.441-32.438,12.121
		c-2.189,1.442-4.1,2.835-5.947,4.179c-7.287,5.309-11.686,8.51-25.911,8.51c-16.3,0-22.703-2.441-33.667-9.778
		C152.395,417,144,405.456,144,389.128c0-30.277,13.377-64.231,35.783-90.823c10.886-12.921,23.517-23.6,36.526-30.885
		C229.713,259.917,243.067,256,256,256c12.934,0,26.287,3.917,39.691,11.42c13.01,7.285,25.64,17.964,36.525,30.885
		C354.623,324.896,368,358.851,368,389.128C368,405.456,359.605,417,353.963,420.776z"/>
	<path d="M308.281,210.265c1.836,0.182,3.709,0.232,5.563,0.151c27.511-1.196,52.146-31.332,56.081-68.607
		c2.395-22.534-3.514-45.004-15.804-60.104c-8.476-10.412-18.783-16.228-30.56-17.392c-1.939-0.186-6.146-0.312-6.146-0.312
		c-26.693,1.161-46.561,29.115-50.542,66.817c-2.604,24.466,0.83,48.248,13.2,63.439
		C287.741,203.671,297.494,209.206,308.281,210.265z M283.186,132.501c3.076-29.156,16.729-51.636,34.936-52.428
		c1.115-0.048,2.261-0.016,3.404,0.098c9.109,0.898,15.696,6.736,19.619,11.476c9.774,11.825,14.436,29.948,12.468,48.479
		c-3.06,28.977-21.216,53.229-40.474,54.067c-1.061,0.046-2.146,0.017-3.229-0.087c-6.324-0.621-12.007-3.927-16.881-9.825
		C283.334,172.556,281.039,152.651,283.186,132.501z"/>
</g>
</svg>
`,
      }}
    />
  )
}
